import { useNavigate } from "react-router-dom";
import { Link } from "@mui/material";
import { useTranslation } from "react-i18next";

interface INavigationItem {
  blok: any;
}

const NavigationListItem = ({ blok }: INavigationItem) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const local = i18n.language;
  const previewTitle = blok?.content?.preview_title || "";

  return (
    <Link
      component="li"
      underline="none"
      sx={{
        justifyContent: "flex-start",
        padding: "8px 24px",
        color: "#000",
        fontSize: "16px",
        lineHeight: "24px",
        transition: "color 0.3s ease",
        backgroundColor: "#fff4ed",
        borderRadius: "16px",
        cursor: "pointer",
        "&:hover": { color: "#F4701B" },
      }}
      onClick={() => {
        navigate(local === "en" ? `/blog/${blok.full_slug}` : `/blog/${i18n.language}/${blok.full_slug}`);
      }}
    >
      {previewTitle}
    </Link>
  );
};

export default NavigationListItem;
